/**
 * @generated SignedSource<<d6537e2a16363f919fb4f5ef7d635ede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedBuyerProtectionBox_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentType": "PdpSharedBuyerProtectionBox_item";
};
export type PdpSharedBuyerProtectionBox_item$key = {
  readonly " $data"?: PdpSharedBuyerProtectionBox_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionBox_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBuyerProtectionBox_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2c4db4d2c6f11a8daef1c031d81f5e63";

export default node;
